// eslint-disable-next-line import/prefer-default-export
export const susuSavings = {
  namespaced: true,
  state: {
    transactionsOpenedStatus: false,
    customers: [],
    summary:{},
    totalCustomers: 0,
    branches: [],
    occupations: [],
    settings: [],
    cycles: [],
    transactions: {},
    fundTransfers: [],
    currentCustomerAccount: {
      id: null,
      accounts: [],
    },
    filter: {
      start: null,
      end: null,
      conType: null,
      tranType: null,
      specificDay: false,
    },
    categories: [],
    expenses: [],
    paymentsFilter: {
      start: null,
      end: null,
      specificDay: false,
    },
    fixedDeposits: [],
    fixedDepositFilter: {
      start: null,
      end: null,
      specificDay: false,
    },
    dashboardFilter: {
      accountType: 'susu',
      periodType: 'date',
      period: null,
      zoomMode: false,
      tableMode: false,
      showPeriodsWithNoActivity: false,
    },
    totalFixedDeposits: 0,
    trends: {
      deposits: Array(24).fill(0),
      withdrawals: Array(24).fill(0),
      labels: [
        '12 AM', '01 AM', '02 AM', '03 AM', '04 AM', '05 AM', '06 AM', '07 AM',
        '08 AM', '09 AM', '10 AM', '11 AM', '12 PM', '01 PM', '02 PM', '03 PM',
        '04 PM', '05 PM', '06 PM', '07 PM', '08 PM', '09 PM', '10 PM', '11 PM',
      ],
    },
    zoomRange: {
      date: {
        min: undefined,
        max: undefined,
      },
      week: {
        min: undefined,
        max: undefined,
      },
      month: {
        min: undefined,
        max: undefined,
      },
      year: {
        min: undefined,
        max: undefined,
      },
    },
    stats: {
      deposits_count: 0,
      withdrawals_count: 0,
      deposits_amount: 0,
      withdrawals_amount: 0,
      net_balance: 0,
    },
  },
  mutations: {
    setZoomRange(state, data) {
      state.zoomRange[data.type] = data.data
    },
    setDashboardFilter(state, filter) {
      state.dashboardFilter = { ...state.dashboardFilter, ...filter }
    },
    setExpenses(state, data) {
      state.expenses = data
    },
    addExpense: (state, expense) => {
      state.expenses = [expense, ...state.expenses]
    },
    updateExpense: (state, expense) => {
      state.expenses = state.expenses.map(datum => {
        if (datum.id === expense.id) {
          return expense
        }
        return datum
      })
    },
    removeExpense: (state, id) => {
      state.expenses = state.expenses.filter(datum => datum.id !== id)
    },

    setFixedDepositFilter(state, data) {
      state.fixedDepositFilter = data
    },
    setFixedDeposits(state, data) {
      state.fixedDeposits = data.data
      state.totalFixedDeposits = data.total
    },
    addFixedDeposit: (state, deposit) => {
      state.fixedDeposits = [deposit, ...state.fixedDeposits]
    },
    updateFixedDeposit: (state, deposit) => {
      state.fixedDeposits = state.fixedDeposits.map(datum => {
        if (datum.id === deposit.id) {
          return deposit
        }
        return datum
      })
    },
    removeFixedDeposit: (state, id) => {
      state.fixedDeposits = state.fixedDeposits.filter(datum => datum.id !== id)
    },

    setCategories(state, data) {
      state.categories = data
    },
    addCategory: (state, category) => {
      state.categories = [category, ...state.categories]
    },
    updateCategory: (state, category) => {
      state.categories = state.categories.map(datum => {
        if (datum.id === category.id) {
          return category
        }
        return datum
      })
    },
    removeCategory: (state, id) => {
      state.categories = state.categories.filter(datum => datum.id !== id)
    },
    addFundTransfer: (state, transfer) => {
      state.fundTransfers = [transfer, ...state.fundTransfers]
    },
    setFundTransfers(state, transfers) {
      state.fundTransfers = transfers
    },
    setFilter(state, filter) {
      state.filter = filter
    },
    setPaymentsFilter(state, filter) {
      state.paymentsFilter = filter
    },
    updateSelection(state, id) {
      state.currentCustomerAccount.accounts = state.currentCustomerAccount.accounts.map(a => {
        a.selected = false
        if (id === a.reference) {
          a.selected = true
        }
        return a
      })
    },
    setCurrentCustomerAccounts(state, data) {
      state.currentCustomerAccount = data
    },
    setCustomerAccount(state, account) {
      state.currentCustomerAccount.accounts = [account, ...state.currentCustomerAccount.accounts]
    },
    updateCustomerAccount(state, data) {
      state.currentCustomerAccount.accounts = state.currentCustomerAccount.accounts.map(datum => {
        if (datum.reference === data.id) {
          return { ...datum, ...data }
        }
        return datum
      })
    },
    setCustomers(state, data) {
      state.customers = data.data
      state.totalCustomers = data.total
      state.summary = data.stats
    },
    addCustomer: (state, customer) => {
      state.customers = [customer, ...state.customers]
      state.totalCustomers += 1
    },
    updateCustomer: (state, customer) => {
      state.customers = state.customers.map(datum => {
        if (datum.id === customer.id) {
          return { ...datum, ...customer }
        }
        return datum
      })
    },
    updateFundTransfer: (state, customer) => {
      state.fundTransfers = state.fundTransfers.map(datum => {
        if (datum.id === customer.id) {
          return { ...datum, ...customer }
        }
        return datum
      })
    },
    removeCustomer: (state, id) => {
      state.customers = state.customers.filter(datum => +datum.id !== +id)
      state.totalCustomers -= 1
    },

    setTransactions(state, data) {
      state.transactions = data
    },
    addTransaction: (state, transaction) => {
      state.transactions.data = [transaction, ...state.transactions.data]
      state.transactions.total += 1
    },
    reverseTransaction: (state, transaction) => {
      const data = state.transactions.data.map(pay => {
        if (pay.id === transaction) {
          return { ...pay, reversed: true }
        }
        return pay
      })
      state.transactions = { data, total: state.transactions.total }
    },
    setCycles(state, data) {
      state.cycles = data
    },
    addCycle: (state, cycle) => {
      state.cycles = [...state.cycles, cycle]
    },
    updateCycle: (state, cycle) => {
      state.cycles = state.cycles.map(datum => {
        if (datum.id === cycle.id) {
          return cycle
        }
        return datum
      })
    },
    removeCycle: (state, id) => {
      state.cycles = state.cycles.filter(datum => +datum.id !== +id)
    },

    setBranches(state, data) {
      state.branches = data
    },
    addBranch: (state, branch) => {
      state.branches = [branch, ...state.branches]
    },
    updateBranch: (state, branch) => {
      state.branches = state.branches.map(datum => {
        if (datum.id === branch.id) {
          return branch
        }
        return datum
      })
    },
    removeBranch: (state, id) => {
      state.branches = state.branches.filter(datum => +datum.id !== +id)
    },
    setSettings(state, data) {
      state.settings = data
    },
    addSetting: (state, setting) => {
      state.settings = [setting, ...state.settings]
    },
    updateSetting: (state, setting) => {
      state.settings = state.settings.map(datum => {
        if (datum.id === setting.id) {
          return setting
        }
        return datum
      })
    },
    removeSetting: (state, id) => {
      state.settings = state.settings.filter(datum => +datum.id !== +id)
    },
    setOccupations(state, data) {
      state.occupations = data
    },
    setDashboardTrends(state, data) {
      state.trends = data
    },
    setDashboardStats(state, data) {
      state.stats = data
    },
    addOccupation: (state, occupation) => {
      state.occupations = [occupation, ...state.occupations]
    },
    updateOccupation: (state, occupation) => {
      state.occupations = state.occupations.map(datum => {
        if (datum.id === occupation.id) {
          return occupation
        }
        return datum
      })
    },
    removeOccupation: (state, id) => {
      state.occupations = state.occupations.filter(datum => +datum.id !== +id)
    },
  },
  getters: {
    customers(state) {
      return state.customers.map(u => ({ ...u, full_name: `${u.first_name} ${u.last_name}` }))
    },
    branches(state) {
      return state.branches
    },
    occupations(state) {
      return state.occupations
    },
    settings(state) {
      return state.settings
    },
    currentCustomerAccount(state) {
      return state.currentCustomerAccount
    },
    cycles(state) {
      return state.cycles
    },
    transactions(state) {
      return state.transactions
    },
    transactionsOpenedStatus(state) {
      return state.transactionsOpenedStatus
    },
    currentTransactionsFilter(state) {
      return state.filter
    },
    currentPaymentsFilter(state) {
      return state.paymentsFilter
    },
    fundTransfers(state) {
      return state.fundTransfers
    },
    expenses(state) {
      return state.expenses
    },
    categories(state) {
      return state.categories
    },
    fixedDeposits(state) {
      return state.fixedDeposits.map(fd => ({ ...fd, label: `${fd.reference}(${(+fd.maturity_amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })})` }))
    },
    fixedDepositFilter(state) {
      return state.fixedDepositFilter
    },
    totalFixedDeposits(state) {
      return state.totalFixedDeposits
    },
    trends(state) {
      return state.trends
    },
    zoomRange(state) {
      return state.zoomRange
    },
    dashboardFilter(state) {
      return state.dashboardFilter
    },
    dashboardStats(state) {
      return state.stats
    },
    totalCustomers(state) {
      return state.totalCustomers
    },
    summary(state) {
      return state.summary
    },
  },
}
